"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let orderModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.no = "";
    this.id = "";
    this.coins = 0;
    this.created_time = "";
    this.discount_coupon = "";
    this.duration = "";
    this.environment_setting = "";
    this.favorable_price = 0;
    this.invoice = "";
    this.ip_setting = "";
    this.operator = "";
    this.original_price = 0;
    this.pay_money = 0;
    this.pay_platform = "";
    this.status = "";
    this.type = "";
    this.vd_count = 0;
    this.vd = null;
    this.currency = "";
    this.consume = "";
  }
};
orderModel.model = "vd.new.order.detail";
orderModel = __decorateClass([
  Annotation.ModelMeta
], orderModel);
export let PaymentNomoneyModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.gift = false;
    this.url = "";
    this.order = new orderModel();
  }
};
PaymentNomoneyModel.model = "payment.nomoney";
PaymentNomoneyModel = __decorateClass([
  Annotation.ModelMeta
], PaymentNomoneyModel);
export let VDUpgradeModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.new_ip = "";
    this.new_region_name = "";
    this.old_ip = "";
    this.old_region_name = "";
  }
};
VDUpgradeModel.model = "vd.upgrade.item";
VDUpgradeModel = __decorateClass([
  Annotation.ModelMeta
], VDUpgradeModel);
